

// import React, { useState, useEffect } from "react";
// import { api } from "../services/api";                 // ✅ use configured axios instance

// const OTPDialog = ({ open, onClose, email, onVerified }) => {
//   const [otp, setOtp] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   useEffect(() => {
//     if (open) {
//       setOtp("");
//       setMessage("");
//     }
//   }, [open]);

//   if (!open) return null;

//   const handleVerify = async () => {
//     if (!email || !otp) {
//       setMessage("Email and OTP are required.");
//       return;
//     }

//     setLoading(true);
//     setMessage("");
//     try {
//       const res = await api.post("/users/verify_email", {
//         email,
//         otp,
//       });

//       setMessage(res.data.message || "OTP Verified!");

//       // ✅ Pass the verified user data (which includes the token) back to parent
//       onVerified && onVerified(res.data.data);
//       onClose();
//     } catch (err) {
//       setMessage(err.response?.data?.message || "OTP verification failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//       <div className="bg-white p-6 rounded-lg shadow max-w-sm w-full">
//         <h2 className="text-lg font-semibold mb-4 text-center">Email Verification</h2>
//         <input
//           type="text"
//           value={otp}
//           onChange={(e) => setOtp(e.target.value)}
//           placeholder="Enter OTP sent to your email"
//           className="w-full border p-2 mb-4 rounded outline-none focus:ring focus:ring-green-300"
//         />
//         {message && (
//           <p className={`mb-4 text-sm text-center ${message.toLowerCase().includes("fail") ? "text-red-600" : "text-green-600"}`}>
//             {message}
//           </p>
//         )}
//         <div className="flex justify-end space-x-2">
//           <button
//             onClick={onClose}
//             className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
//             disabled={loading}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleVerify}
//             className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
//             disabled={loading}
//           >
//             {loading ? "Verifying..." : "Verify"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OTPDialog;

import React, { useState, useEffect } from "react";
import { api } from "../services/api";

const OTPDialog = ({ open, onClose, email, onVerified }) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (open) {
      setOtp("");
      setMessage("");
    }
  }, [open]);

  if (!open) return null;

  // ✅ Only allow digits, max 4 characters
  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 4) {
      setOtp(value);
    }
  };

  const handleVerify = async () => {
    if (!email) {
      setMessage("Email is required.");
      return;
    }

    // ✅ Validate OTP length
    if (otp.length !== 4) {
      setMessage("Please enter a 4-digit OTP.");
      return;
    }

    setLoading(true);
    setMessage("");
    try {
      const res = await api.post("/users/verify_email", {
        email,
        otp: parseInt(otp, 10),                       // ✅ Send as number
      });

      setMessage(res.data.message || "OTP Verified!");

      onVerified && onVerified(res.data.data);
      onClose();
    } catch (err) {
      setMessage(err.response?.data?.message || "OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Allow Enter key to submit when OTP is complete
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && otp.length === 4 && !loading) {
      handleVerify();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow max-w-sm w-full">
        <h2 className="text-lg font-semibold mb-2 text-center">Email Verification</h2>
        <p className="text-sm text-gray-600 text-center mb-4">
          Enter the 4-digit OTP sent to your email
        </p>

        <input
          type="text"
          value={otp}
          onChange={handleOtpChange}
          onKeyDown={handleKeyDown}
          placeholder="••••"
          className="w-full border p-2 mb-4 rounded outline-none focus:ring focus:ring-green-300 text-center text-2xl tracking-widest"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={4}
          autoFocus
        />

        {message && (
          <p
            className={`mb-4 text-sm text-center ${
              message.toLowerCase().includes("fail") ||
              message.toLowerCase().includes("invalid") ||
              message.toLowerCase().includes("required")
                ? "text-red-600"
                : "text-green-600"
            }`}
          >
            {message}
          </p>
        )}

        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleVerify}
            className={`px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 ${
              loading || otp.length !== 4 ? "opacity-60 cursor-not-allowed" : ""
            }`}
            disabled={loading || otp.length !== 4}
          >
            {loading ? "Verifying..." : "Verify"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OTPDialog;